import React from 'react';
import {Link} from "react-router-dom";
import List from "../List";

const CourseTypeFive = ({ data, classes }) => {

    return (
        <div className={`edu-course course-style-4 course-style-8 ${ classes ? classes : '' }`}>
            <div className="inner">
                <div className="thumbnail" style={{maxWidth: "260px"}}>
                    <Link to={`/course/${data.id}`}>
                        <a>
                            {data.image240x135 ?
                                <img className="image" src={data.image240x135} alt="course-image" /> :
                                <img className="image" src="/assets/images/placeholderImage.jpg" alt="course-image"/>
                            }
                        </a>
                    </Link>
                    {/*<div className="time-top">*/}
                    {/*    <span className="duration">*/}
                    {/*        <i className="icon-61"></i>*/}
                    {/*        {data.duration}*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                </div>

                <div className="content">
                    {/*<div className="course-price">*/}
                    {/*    ${data?.course_price}*/}
                    {/*</div>*/}

                    <h6 className="title">
                        <Link to={`/course/${data.id}`}>
                            <a>{data.title}</a>
                        </Link>
                    </h6>

                    {/*<div className="course-rating">*/}
                    {/*    <div className="rating">*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*    </div>*/}
                    {/*    <span className="rating-count">*/}
                    {/*        ({data.rating} /{data.rating_count}{" "} Rating)*/}
                    {/*    </span>*/}
                    {/*</div>*/}

                    <p>{data.headline}</p>

                    <p>{data.visibleInstructorList?.map((instructor, id) => {return instructor.displayName + " "})}</p>

                    <ul className="course-meta">
                        <li><i className="icon-24"></i>{data.numOfPublishedLectures} Ders</li>
                        <li><i className="icon-61"></i>{data.contentInfo}</li>
                        <li>{data.instructionalLevel}</li>
                    </ul>
                </div>
            </div>
            <div className="hover-content-aside">
                <div className="content">
                    <span className="course-level">
                        {data.level}
                    </span>

                    <h5 className="title">
                        <Link to={`/course-details/${data.id}`}>
                            <a>{data.title}</a>
                        </Link>
                    </h5>

                    {/*<div className="course-rating">*/}
                    {/*    <div className="rating">*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*    </div>*/}
                    {/*    <span className="rating-count">*/}
                    {/*        ({data.rating})*/}
                    {/*    </span>*/}
                    {/*</div>*/}

                    <ul className="course-meta">
                        <li><i className="icon-24"></i>{data.numOfPublishedLectures} Ders</li>
                        <li><i className="icon-61"></i>{data.contentInfo}</li>
                        <li>{data.instructionalLevel}</li>
                    </ul>

                    <div className="course-feature">
                        <h6 className="title">Öğrenecekleriniz</h6>
                        <List data={data.objectives}/>
                        <ul>
                        {/*{ */}
                            {/*    data.features.slice(0, 3).map( (feature, featurekey) => <li key={ featurekey }>{ feature }</li> )*/}
                            {/*}*/}
                        </ul>
                    </div>

                    <div className="button-group">
                        <Link to={`/course/${data.id}`} className="edu-btn btn-medium">
                        <a onClick="" className="edu-btn btn-medium">
                            Kursa Git
                        </a>
                        </Link>
                        {/*<button onClick="" className={`btn-outline-dark wishlist-btn`}><i className="icon-22"></i></button>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CourseTypeFive;